import { Components, Theme } from '@mui/material';

const MuiMenu: Components<Theme>['MuiMenu'] = {
  styleOverrides: {
    list: ({ theme }) => ({
      padding: 0,
      gap: 0,
      display: 'flex',
      flexDirection: 'column',

      '& .MuiMenuItem-root:not(:last-of-type)': {
        borderBottom: `1px solid ${theme.palette.grey[300]}`,
      },
    }),
    paper: ({ theme }) => ({
      boxShadow: 'none',
      border: `1px solid ${theme.palette.grey[300]}`,
    }),
  },
};

export default MuiMenu;
